import { lazy } from "react";

export const LazyQueryStringWidgetEditInsert = lazy(() =>
    import(/* webpackChunkName: "QueryStringWidget" */ "./EditInsert").then(
        x => ({ default: x.EditInsert })
    )
);
